
export function setInstallments(state, data) {
  state.installments = data
}

export function setSites(state, data) {
    state.sites = data
}

export function setContractId(state, data) {
    state.contractId = data
}



